import crud from '@/crud/index/index'

import computed from './computed'
import data from './data'
import methods from './methods'

export default {
  computed,
  data,
  methods,
  resourcePath: 'v1/search/professionals/specialities/?limit=false&pagination=false',

  mixins: [crud]
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/identification/resources/index.js